
require('page-common/index.js');

require('page-common/js/popup-form-data-api.js');
require('page-common/js/inline-form-data-api.js');
// require('page-common/js/visibility-condition-data-api'); Модуль был удалён в рамках RGSSUP-22285
require('page-common/js/postscribe-script-data-api');
require('page-common/js/usability-markup')();
require('page-common/js/accordeon-remote-toggle')();
//require('page-common/js/navbar-item-location'); Модуль был удалён в рамках RGSSUP-22744
require('page-common/js/lk-button');
require('modal-redirect-to-other-site');
